import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import type { BloqueioAlteracoes } from './use-blocker-dirty';

/** Confirmacao de saida com alteracoes nao salvas. Use com o retorno de `useBlockerDirty`. */
export function SaidaComAlteracoesDialog({ bloqueado, sair, ficar }: BloqueioAlteracoes) {
  return (
    <AlertDialog open={bloqueado} onOpenChange={(aberto) => !aberto && ficar()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Sair sem salvar?</AlertDialogTitle>
          <AlertDialogDescription>
            Este registro tem alterações que ainda não foram salvas. Se sair agora, elas serão perdidas.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Continuar editando</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              // Sem preventDefault o Radix fecha o dialogo e chamaria ficar() (reset) em cima do proceed().
              e.preventDefault();
              sair();
            }}
            className="bg-destructive text-white hover:bg-destructive/90"
          >
            Sair sem salvar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
